import React, { useState, useEffect } from 'react';
import { CookieBanner } from './CookieBanner';

// localStorage utility functions
const getCookieConsent = (): string | null => {
    try {
        return localStorage.getItem('cookieConsent');
    } catch (error) {
        console.warn('localStorage not available:', error);
        return null;
    }
};

interface CookieConsentProviderProps {
    assistantName: string;
    onConsentChange?: (consented: boolean) => void;
    children: (hasConsented: boolean, checkConsent: () => boolean, showBanner: () => void) => React.ReactNode;
}

export const CookieConsentProvider: React.FC<CookieConsentProviderProps> = ({
                                                                                assistantName,
                                                                                onConsentChange,
                                                                                children
                                                                            }) => {
    const [hasConsented, setHasConsented] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [forceShowBanner, setForceShowBanner] = useState(false);

    // Check for existing consent on component mount
    useEffect(() => {
        const consentStatus = getCookieConsent();
        const consented = consentStatus === 'accepted';
        setHasConsented(consented);
        setIsLoading(false);
        onConsentChange?.(consented);
    }, [onConsentChange]);

    const checkConsent = (): boolean => {
        const consentStatus = getCookieConsent();
        return consentStatus === 'accepted';
    };

    const showBanner = () => {
        setForceShowBanner(true);
    };

    const handleConsentChange = (consented: boolean) => {
        setHasConsented(consented);
        setForceShowBanner(false);
        onConsentChange?.(consented);
    };

    // Don't render children until we've checked consent status
    if (isLoading) {
        return null;
    }

    return (
        <>
            {children(hasConsented, checkConsent, showBanner)}
            <CookieBanner
                assistantName={assistantName}
                onConsentChange={handleConsentChange}
                forceVisible={forceShowBanner}
            />
        </>
    );
};